import { CHANGE_SALES_REP_MODAL as FEATURE_PREFIX } from 'featurePrefix.ids'

const ids = {
  Title: `${FEATURE_PREFIX}__title`,
  UpdateSelected: `${FEATURE_PREFIX}__update-selected`,
  UpdateSelectedRadioButton: `${FEATURE_PREFIX}__update-selected__radio-button`,
  UpdateAllRadioButton: `${FEATURE_PREFIX}__update-all__radio-button`,
  UpdateAllFiltered: `${FEATURE_PREFIX}__update-all-filtered`,
} as const

export default ids
